import React from 'react';
import useStyles from './styles'

import Header from '../../components/Header';
import BoardCard from '../../components/BoardCard';
import Loading from '../../components/Loading';

function Layout({boards, loading}) {
  const c = useStyles();

  return (
    <>
      <Header newBoard></Header>
      <div className={"container " + c.pageContainer} style={loading ? {justifyContent: 'center'} : {}}>
        {loading && <Loading></Loading>}
        {!loading && (
          <>
            <section>
              <h2>Your Boards</h2>
              <div className={c.boardsArea}>
                {boards?.yourBoards?.map(board => {
                  return <BoardCard title={board.title} description={board.description} id={board.id}></BoardCard>
                })}
                {boards?.yourBoards?.length === 0 && <span>Nothing found</span>}
              </div>
            </section>
            <section>
              <h2>Shared With You</h2>
              <div className={c.boardsArea}>
                {boards?.sharedWithYou?.map(board => {
                  return <BoardCard title={board.title} description={board.description} id={board.id}></BoardCard>
                })}
                {boards?.sharedWithYou?.length === 0 && <span>Nothing found</span>}
               
              </div>
            </section>
          </>
        )}
        
      </div>
    </>
  );
}

export default Layout;